<template>
  <Modal
    v-model="modalOpened"
    @on-ok="handleSubmit('formItem')"
    :loading="loading"
    width="1000"
    title="批量设置权限"
  >
    <div class="permissions-context">
      <div class="search-customer">
        <h3>搜索客户</h3>
        <Input
          placeholder="请输入客户名"
          clearable
          style="width: 250px"
          search
          v-model="searchtext"
          @on-change="searchCustomer"
        />
        <!-- 搜索客户列表 -->
        <div class="customer-wrapper">
          <div
            v-for="item in bulkCustomers"
            @click="addCustomer(item)"
            :key="item._id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 已选客户列表 -->
      <div class="choose-tot">
        <h3>已选客户</h3>
        <div class="tot">共{{ choosedCustomerList.length }}个</div>
        <div class="chooselist-wrapper">
          <div
            class="choose-list"
            v-for="item in choosedCustomerList"
            @click="deleteCustomer(item)"
            :key="item._id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="permissions-set">
        <h3>设置权限</h3>
        <div class="permissions-list">
          <Form
            @submit.native.prevent
            ref="formItem"
            :model="formItem"
            :rules="ruleValidate"
            label-position="top"
          >
            <FormItem label="开发人员" prop="devSales" style="width: 366px">
              <Select
                v-model="formItem.devSales"
                filterable
                multiple
                placeholder="请选择开发人员"
                :loading="devloading"
              >
                <Option
                  v-for="(option, index) in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem
              label="维护人员"
              prop="maintainSales"
              style="width: 366px"
            >
              <Select
                v-model="formItem.maintainSales"
                filterable
                multiple
                placeholder="请选择维护人员"
                :loading="maintenanceloading"
              >
                <Option
                  v-for="(option, index) in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="回款人员" prop="paybacker" style="width: 366px">
              <Select
                v-model="formItem.paymentSales"
                filterable
                multiple
                placeholder="请选择维护人员"
                :loading="maintenanceloading"
              >
                <Option
                  v-for="(option, index) in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem
              label="销售数据可见人员"
              prop="salesDataer"
              style="width: 366px"
            >
              <Select
                v-model="formItem.salesVisibleMember"
                filterable
                multiple
                placeholder="请选择销售数据可见人员"
                :loading="maintenanceloading"
              >
                <Option
                  v-for="(option, index) in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem
              label="技术配方可见人员"
              prop="reciper"
              style="width: 366px"
            >
              <Select
                v-model="formItem.techVisibleMember"
                filterable
                multiple
                placeholder="请选择技术配方可见人员"
                :loading="maintenanceloading"
              >
                <Option
                  v-for="(option, index) in userList"
                  :value="option._id"
                  :key="option._id"
                  >{{ option.name }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="部门" prop="department" style="width: 366px">
              <Select
                placeholder="请选择部门"
                v-model="formItem.department"
                style="width: 200px"
              >
                <Option
                  v-for="item in departmentList"
                  :value="item._id"
                  :key="item._id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Form>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "BulkPermissionsModal",
  data() {
    return {
      modalOpened: false,
      searchtext: "",
      loading: true,
      departmenttxt: "",
      devSales: undefined,
      maintainSales: undefined,
      paybacker: undefined,
      salesDataer: undefined,
      reciper: undefined,
      devloading: false,
      maintenanceloading: false,
      choosedCustomerList: [],
      page: 0,
      formItem: {
        devSales: [],
        maintainSales: [],
        paymentSales: [],
        salesVisibleMember: [],
        techVisibleMember: [],
        department: undefined,
      },
      ruleValidate: {},
    };
  },
  computed: {
    ...mapState({
      bulkCustomers: (state) => state.customer.bulkCustomers,
      userList: (state) => state.user.userList,
      departmentList: (state) => state.department.departmentList,
      customerPurviewList: (state) => state.customerPurview.customerPurviews,
    }),
  },
  methods: {
    ...mapActions({
      getBulkCustomers: "customer/getbulkcustomersAction",
      getUsers: "user/getUsersAction",
      getDepartmentList: "department/getDepartmentListAction",
      createCustomerPurview: "customerPurview/createCustomerPurviewAction",
      getCustomers: "customer/getCustomersAction",
    }),
    async openModal(spo) {
      Object.assign(this.$data, this.$options.data());
      this.modalOpened = true;
    },
    async loadCustomer(page) {
      if (page) this.page = page - 1;
      let api = {
        skip: this.page * 15,
        limit: 15,
      };
      if (this.searchtext) api.searchText = this.searchtext;
      try {
        this.tableLoading = true;
        await this.getBulkCustomers(api);
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchCustomer() {
      this.page = 0;
      this.loadCustomer();
    },
    // 添加客户到已选列表
    addCustomer(item) {
      this.choosedCustomerList.push(item);
      this.choosedCustomerList = this.unique(this.choosedCustomerList);
    },
    // 删除已选客户列表
    deleteCustomer(data) {
      for (let i = 0; i < this.choosedCustomerList.length; i++) {
        if (this.choosedCustomerList[i]._id == data._id) {
          this.choosedCustomerList.splice(i, 1);
        }
      }
    },
    // 除重
    unique(a) {
      let res = [];
      for (let i = 0; i < a.length; i++) {
        let item = a[i];
        res.indexOf(item) === -1 && res.push(item);
      }
      return res;
    },
    // 提交权限表单
    async handleSubmit() {
      try {
        let data;
        if (this.choosedCustomerList.length > 0) {
          let choosedCustomerId = this.choosedCustomerList.map(
            (item) => item._id
          );
          data = {
            customer: choosedCustomerId,
            ...this.formItem,
          };
          await this.createCustomerPurview(data);

          const api = {
            skip: this.page * 15,
            limit: 15,
          };
          this.getCustomers(api);
          this.$Message.success("保存成功!");
          this.modalOpened = false; //关闭表单
        } else {
          this.loading = false;
          // 让按钮从loading状态恢复正常
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$Message.error("保存失败!");
        }
      } catch (error) {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
        this.$Message.error(`失败: ${error}`);
      }
    },
  },
  created() {
    // 获取客户列表
    this.searchCustomer();
    // 获取用户列表
    this.getUsers();
    // 获取部门
    this.getDepartmentList();
  },
};
</script>

<style scoped lang="stylus">
.permissions-context
  display flex
  justify-content space-between

  h3
    margin-bottom 10px

.chooselist-wrapper
  margin-top 20px

  .choose-list
    font-size 20px
    cursor pointer

.tot
  line-height 32px

.customer-wrapper
  margin 5px 0 0 5px

  div
    cursor pointer
    font-size 20px
</style>